export const alpha_dash = (value) => {
    return /^[a-zA-Z0-9_\-]+$/.test(value);
};
